const cardBodyStyle = theme => ({
  cardBody: {
    [theme.breakpoints.up("md")]: {
      padding: "0.9375rem 20px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "5px",
      paddingRight: "5px",
    },
    flex: "1 1 auto",
    WebkitBoxFlex: "1",
    position: "relative"
  },
  cardBodyPlain: {
    paddingLeft: "5px",
    paddingRight: "5px"
  },
  cardBodyProfile: {
    marginTop: "15px"
  }
});

export default cardBodyStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/components/cardBodyStyle.jsx